import { CloseLetterReqDTO } from '../dtos/closeLetterReqDTO';
import { UpdateLetterReqDTO } from '../dtos/updateLetterReqDTO';
import axiosBearerClient from './axiosBearerClient';
import { useQuery } from '@tanstack/react-query';

export const useGetLetter = (referenceCode?: string) => {
	const { isFetching, error, data, isError, refetch } = useQuery({
		queryKey: ['letter', referenceCode],
		enabled: !!referenceCode,
		retry: false,
		queryFn: async ({ queryKey }) => {
			return await axiosBearerClient.get(`/reminder-letters/${queryKey[1]}`);
		},
	});

	return {
		isFetching,
		error,
		isError,
		data,
		refetch,
	};
};
export const useCloseLetter = (
	closeLetter?: CloseLetterReqDTO,
	enable?: boolean
) => {
	const { isFetching, error, data, isError, refetch } = useQuery({
		queryKey: ['closeLetter'],
		enabled: false,
		retry: false,
		queryFn: async () =>
			await axiosBearerClient.patch(
				`/reminder-letters/close-letter/${closeLetter?.referenceCode}`,
				closeLetter
			),
	});

	return {
		isFetching,
		error,
		isError,
		data,
		refetch,
	};
};

export const useUpdateLetter = (
	updateLetter?: UpdateLetterReqDTO,
	enable?: boolean
) => {
	const { isFetching, error, data, isError, refetch } = useQuery({
		queryKey: ['encodeIndexes'],
		enabled: false,
		retry: false,
		queryFn: async () =>
			await axiosBearerClient.put(
				`/reminder-letters/${updateLetter?.referenceCode}`,
				updateLetter
			),
	});

	return {
		isFetching,
		error,
		isError,
		data,
		refetch,
	};
};
